(function () {
  function initFragrance(section) {
    var thumbs    = section.querySelectorAll('.fragrance-banner__thumb');
    var descs     = section.querySelectorAll('.fragrance-banner__desc');
    var container = section.querySelector('.fragrance-banner__thumbs');

    function showDesc(id) {
      descs.forEach(function (d) {
        d.classList.toggle('is-active', d.dataset.thumbDesc === id);
      });
    }

    function isTouch() {
      return window.matchMedia('(hover: none)').matches;
    }

    thumbs.forEach(function (thumb) {
      // desktop: hover
      thumb.addEventListener('mouseenter', function () {
        if (isTouch()) return;
        var id = this.dataset.thumbId;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
        showDesc(id);
      });

      // mobile: tap to toggle
      thumb.addEventListener('click', function () {
        if (!isTouch()) return;
        var id = this.dataset.thumbId;
        var active = this.classList.contains('is-active');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        if (!active) {
          this.classList.add('is-active');
          showDesc(id);
        } else {
          showDesc('default');
        }
      });
    });

    // desktop: reset on mouse-leave strip
    if (container) {
      container.addEventListener('mouseleave', function () {
        if (isTouch()) return;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        showDesc('default');
      });
    }
  }

  document.querySelectorAll('[data-section-type="fragrance-banner"]').forEach(initFragrance);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-section-type="fragrance-banner"]');
    if (s) initFragrance(s);
  });
})();
